import { z } from "zod";
import { apiBaseUrlSchema, optionalEnv, parseEnv } from "@academia-hub/validation";

const clientEnvSchema = z.object({
  VITE_API_BASE_URL: apiBaseUrlSchema.default("http://localhost:3000/api/v1"),
  /**
   * Dev-only stand-in for "the browser is on this tenant's subdomain" until Phase 02 ships real
   * login and session-based tenant resolution — see ADR-0003
   * (docs/decisions/0003-interim-tenant-resolution-before-auth.md). Sent as the `X-Tenant-Slug`
   * header on every API request; the API refuses to honor this header at all when it's running
   * with `NODE_ENV=production`, so leaving this unset in a production build is harmless, not
   * merely conventional.
   */
  VITE_DEV_TENANT_SLUG: optionalEnv(z.string().min(1)),
  /**
   * KG-13: where the user guide (`docs/user-guide/*.md`) is published; the Help page links each
   * role's guide as `<base>/<file>.md`. Defaults to the guide in the project repository.
   */
});

export const env = parseEnv(clientEnvSchema, import.meta.env);
